module.exports = __webpack_public_path__ + "img/intro_2.0827b8b9.jpg";